import cx from 'clsx';
import * as React from 'react';

import styles from './Banner.module.scss';

const BannerGhost: React.FC<{ standalone?: boolean }> = ({
  standalone = true,
}) => (
  <div className={cx(standalone)}>
    <div
      data-testid="banner-ghost"
      className={cx(styles.ghostWrapper, standalone && styles.ghost)}
    ></div>
  </div>
);

export default BannerGhost;
